module.exports = __webpack_public_path__ + "static/media/12_Lee_L@2x.c72ccade.jpg";